export { title } from "../../content";

export const footnotes = [
  {
    text: (
      <span>
        <sup>1</sup>
        As of 01/01/2017 London properties are subject to a 3 month maximum
        rental limit via Airbnb per year. With this in mind, monthly ROI
        timescales abiding to this rule can be found below. For properties on
        the less expensive end of the scale, this puts the ROI timescale very
        close to that of traditional renting. The regulation from Airbnb can be
        nullified if the homeowner can provide the platform with written
        permission from their local council.
      </span>
    ),
    id: "airbnb-uk-footnote-1",
  },
  {
    text: (
      <span>
        Without this permission the time scale for ROI in London Boroughs is as
        follows: Southwark, 360 months; Croydon, 376 months; Bexley, 412 months;
        Newham, 420 months; Barking & Dagenham tied with Richmond upon Thames,
        452 months; Hillingdon, 504 months; Harrow, 508 months; Tower Hamlets,
        524 months; Lambeth, 532 months; Sutton, 548 months; Enfield, 600
        months; Redbridge, 624 months; Ealing, 652 months; Greenwich, 684
        months; Camden, 704 months; Bromley, 716 months; Kingston upon Thames,
        724 months; Wandsworth, 748 months; Hounslow, 756 months; City of
        Westminster, 760 months; Lewisham, 796 months; Haringey, 808 months;
        Brent, 828 months; Merton tied with Hackney 864 months; Hammersmith &
        Fulham, 884 months; Waltham Forest, 888 months; Barnet, 892 months; City
        of London, 896 months; Islington, 900 months; Kensington & Chelsea, 1520
        months.
      </span>
    ),
    id: "airbnb-uk-footnote-2",
  },
  {
    text: (
      <span>
        <sup>2</sup>
        We looked at all confirmed sales in the city records for 3-bedroom
        properties within the city limits for the past 6 months. We also used
        data from the World Bank and the HSBC.
      </span>
    ),
    id: "airbnb-uk-footnote-3",
  },
  {
    text: (
      <span>
        <sup>3</sup>
        We looked at all available properties with the same specifications as
        those in the sold section available for rent in the past 12 months in
        all major rental platforms and real estate agents within the city. This
        changed from country to city. We looked at data from the Word Bank, HSBC
        Property ROI Index, hundreds of property websites and contacted major
        real estate providers in each city.
      </span>
    ),
    id: "airbnb-uk-footnote-4",
  },
  {
    text: (
      <span>
        <sup>4</sup> For Airbnb costs we looked at all available Airbnb
        properties with the same specifications as those being sold and rented
        in each city for a period of 12 months. We then looked at the average 12
        month price, and assumed the property would be rented at an 80%
        capacity. Cities with Airbnb legal restrictions have been indicated in
        the table.
      </span>
    ),
    id: "airbnb-uk-footnote-5",
  },
  {
    text: (
      <span>
        <sup>5</sup> The cities listed here have already been legislated to
        limit the number of days or ways in which people can rent their property
        through services like Airbnb. Still the numbers in this Index are based
        on non-restricted data in order to present a hypothetical scenario. If
        you are interested in getting the actual time it would take, then please
        email us at press@nested.com.
      </span>
    ),
    id: "airbnb-uk-footnote-6",
  },
  {
    text: (
      <span>
        <sup>6</sup> The results for London within the international table and
        the results for London within the London centric tables are different
        due to the methodology used to ensure consistency throughout the
        international tables. Within the international table, findings were
        based in the main 3 boroughs of the city, and to keep the International
        comparison accurate the same methodology was used for London (Camden,
        Islington and City of Westminster). Within the London centric table, as
        all 32 boroughs were taken into account this affected the overall
        average costs.
      </span>
    ),
    id: "airbnb-uk-footnote-7",
  },
];

export const buttons = [
  {
    text: "London",
    categoryUrl: "/london",
  },
  {
    text: "UK",
    categoryUrl: "/all",
  },
];
